module.exports = __webpack_public_path__ + "static/media/convertidor-01.6cb23166.jpg";